import { array, object, string } from '@mojotech/json-type-validation'

export const problemCategoryDecoder = object({
  categoryId: string(),
  users: array(string())
})
